module.exports = {
  MAPS_API_BASE_URL: 'api/v1/map'
};
